import { render, staticRenderFns } from "./full-alert.vue?vue&type=template&id=e11888d6&scoped=true&"
import script from "./full-alert.vue?vue&type=script&lang=ts&"
export * from "./full-alert.vue?vue&type=script&lang=ts&"
import style0 from "./full-alert.vue?vue&type=style&index=0&id=e11888d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11888d6",
  null
  
)

export default component.exports